export default __webpack_public_path__ + "static/media/avatar.47b47fa6.png";